import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import DeformationFieldPanel from '~/components/dvf/DeformationFieldPanel';
import DeformedPreviewSection from '~/containers/viewer/registration-qa/DeformedPreviewSection';
import { useSelectedDeformationField } from '~/hooks/viewer/useSelectedDeformationField';

export default function RegisterVisualizationPanel() {
    const deformationField = useSelectedDeformationField();

    if (!deformationField) {
        return (
            <Box px={1.5} pt={1} pb={1.5}>
                <Typography
                    fontSize={11}
                    color="text.secondary"
                    data-testid="replanning-no-deformation-field"
                >
                    <FormattedMessage id="replanning.visualize.noField" />
                </Typography>
            </Box>
        );
    }

    return (
        <Box
            px={1.5}
            pt={1}
            pb={1.5}
            display="flex"
            flexDirection="column"
            gap={1}
        >
            <DeformationFieldPanel field={deformationField} />
            <DeformedPreviewSection />
        </Box>
    );
}
